import { Text, View, Image, StyleSheet, } from "@react-pdf/renderer";
import LeadFlow from '../../Assets/Images/lead-icon-flow.png'
import highFlow from '../../Assets/Images/highFlow.png'

const GroupLeadershipVisionarytoCollaborative = () => {
  const styles = StyleSheet.create({
    page: {
      paddingHorizontal: 21,
      paddingVertical: 30,
      backgroundColor: '#FFFFFF',
      justifyContent: "space-between",
      height: '100%'
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderBottom: '1px solid #00577D',
      paddingBottom: 5,
      marginBottom: 2,
      marginTop: '-15px'
    },
    titlemain: {
      fontSize: 12,
      fontWeight: 700,
      color: '#76A3BE',
    },
    title: {
      fontSize: 11,
      fontWeight: 200,
      color: '#76A3BE',
    },
    rightsection: {
      alignItems: 'flex-end',
      flexDirection: 'column',
      flex: 1,
    },
    rightText: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    rightTextsybtext: {
      fontSize: 8,
      textAlign: 'right',
      fontWeight: 700,
      color: '#76A3BE',
    },
    section: {
      marginVertical: 10,
    },
    headertext: {
      fontSize: 16,
      fontWeight: 700,
      color: '#245775',
      marginLeft: 0,
      paddingLeft: 0
    },
    paragraph: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 5,
      fontFamily: 'Lato',
      lineHeight: '18px',
    },
    container: {
      flexDirection: 'row',
      marginTop: 10,
      fontFamily: 'Lato',
    },
    containerrightsection: {
      marginLeft: 25,
      maxWidth: 295,
      lineHeight: '18px',
      gap: 15
    },
    image: {
      width: 231,
      height: 231,
      alignSelf: 'center',
    },
    flowimg: {
      marginTop: 30,
    },
    paragraphtopspace: {
      fontSize: 12,
      textAlign: 'justify',
      fontWeight: 400,
      color: '#245775',
      marginBottom: 5,
      fontFamily: 'Lato',
      marginTop: 12
    },
    footer: {
      width: 540,
      borderTop: '1px solid #00577D',
      paddingTop: 5,
      flexDirection: 'row',
      justifyContent: 'space-between',
      position: 'absolute',
      bottom: 15,
      left: 10,
      right: 21,
    },
    footersection: {
      flexDirection: 'column'
    },
    footerTextheading: {
      fontSize: 10,
      fontWeight: 700,
      fontFamily: 'Lato',
      color: '#76A3BE',
    },
    footerText: {
      fontSize: 8,
      fontFamily: 'Lato',
      fontWeight: 400,
      color: '#76A3BE',
    },
    noteContainer: {
       padding: "12% 4% 0 4%",
        alignItems: "center",
         display: "flex",
        justifyContent: "center"
    
      },
      
      noteBold: {
        fontSize: 12,
        fontWeight: 700, 
        fontFamily: "Lato",
        color: "#426B88",
      },
      
      noteText: {
        fontSize: 12,
        fontWeight: 400, 
        color: "#426B88", 
        lineHeight: 2,    
        letterSpacing: 0, 
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center", 
      },
  });

  return (
    <View style={styles.page}>
      <View>
        {/* Header */}
        <View style={styles.header}>
          <View style={styles.headerleft}>
            <Text style={styles.titlemain}>QUADRANT FLOW</Text>
            <Text style={styles.title}>Life & Leadership Assssment</Text>
          </View>
          <View style={styles.rightsection}>
            <Text style={styles.rightText}>Rob Murray</Text>
            <Text style={styles.rightTextsybtext}>Atlas Real Estate{"\n"}Oct 18, 2024</Text>
          </View>
        </View>

        <View style={styles.container}>
          <View style={styles.containersection}>
            <Text style={styles.headertext}>You flow from Visionary to Collaborative</Text>
          </View>
        </View> 

        {/* Content */}
        <View style={styles.section}>
          <Text style={styles.paragraph}>
          When Visionary Groups transition to their Collaborative energy, they meld their grand, innovative ideas with a more inclusive and team-oriented approach. They begin to emphasize the importance of collective input and teamwork for realizing that vision.
          </Text>
        </View>
        <View style={styles.container}>
          <Image src={LeadFlow} style={styles.image} />
          <View style={styles.containerrightsection}>
            <Text style={styles.paragraph}>
            They recognize that integrating varied insights can enrich their ideas or vision and make implementation more effective and universally acceptable. They want others to feel empowered by their contributions and participation in shaping the direction. 
            </Text>
            <Text style={styles.paragraph}>
            A group may create platforms for open communication where ideas are freely exchanged and developed collectively. This approach not only enhances team cohesion but also ensures that each member feels a personal stake in the success of the collective endeavor.
            </Text>
          </View>
        </View> 
          <Image src={highFlow} style={styles.flowimg} />

          <View style={styles.noteContainer}>
          <Text>
            <Text style={styles.noteBold}>Note:</Text>
            <Text style={styles.noteText}>
                {" "}
                Your group exhibits an equal flow between the Collaborative
                and Leadership styles, moving seamlessly in both directions.
            </Text>
          </Text>
        </View>
      </View>
      
      {/* Footer Section */}
      <View style={styles.footer}>
        <View style={styles.footersection}>
          <Text style={styles.footerTextheading}>SELF REPORT</Text>
          <Text style={styles.footerText}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
        </View>
        <Text style={styles.footerTextheading}>PAGE</Text>
      </View>
    </View>
  );
}

export default GroupLeadershipVisionarytoCollaborative;